// extracted by mini-css-extract-plugin
export default {"banner":"kdKQoBeNFWW1lScjIQbb","sprite":"PRd1hmxULUh40vBrsniC"};